import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    uid: 0,
    userInfo: {
      countryId: 0
    },
    now: 0,
    groupRank1: {
      scroll: '',
      hasMore: true,
      list: []
    },
    groupRank2: {
      scroll: '',
      hasMore: true,
      list: []
    },
    toastContent: '',
    loading: false,
    loadMore: false
  }

  @action async setUid(uid) {
    this.data.uid = uid
  }

  @action async GetUserInfoWeb(uid) {
    if (uid == '' || uid == 0) {
      return
    }
    let map = {
      uid: uid
    }
    let d = await http.post('/web/MyAccountInfo', map)
    if (d && d.code == 0 && d.res && d.res.uid > 0) {
      this.data.userInfo = d.res
    }
  }

  @action async groupRank(refresh, dtype) {
    let groupRank = this.data[`groupRank${dtype}`]
    if (this.data.loadMore == false && groupRank.hasMore == true) {
      if (refresh == true) {
        groupRank.scroll = ''
      }

      this.data.loadMore = true
      let d = await http.post('/web/GroupSupper/GroupCountryRank', { dtype, scroll: groupRank.scroll })
      this.data.loadMore = false
      if (!d.res.list || (d.res.list && d.res.list.length == 0)) {
        d.res.hasMore = false
      }
      if (d.res.list && d.res.list.length > 0) {
        for (let i = 0; i < d.res.list.length; i++) {
          if (d.res.list[i].val > 1000000) {
            d.res.list[i].val = parseInt(d.res.list[i].val / 100000) / 10 + 'M'
          } else if (d.res.list[i].val > 1000) {
            d.res.list[i].val = parseInt(d.res.list[i].val / 100) / 10 + 'K'
          }
        }
        if (refresh == true) {
          groupRank.list = []
        }
        groupRank.scroll = d.res.scroll
        groupRank.hasMore = d.res.hasMore
        groupRank.list = groupRank.list.concat(d.res.list) || []
      }
    }

    if (dtype == 1) {
      this.data.groupRank1 = groupRank
    } else {
      this.data.groupRank2 = groupRank
    }
  }

  @action async setToastContent(toastContent) {
    this.data.toastContent = toastContent
  }
}



// WEBPACK FOOTER //
// src/store/app/roomsupport-register.js